import { toast } from "react-toastify";

export const notify = {
  success: (message: string) =>
    toast.success(message),

  error: (message: string) =>
    toast.error(message),

  warning: (message: string) =>
    toast.warn(message),

  info: (message: string) =>
    toast.info(message),

  loading: (message: string) =>
    toast.loading(message),

  dismiss: (id?: string) =>
    toast.dismiss(id),
};

export const notifyPromise = <T>(
  promise: Promise<T>,
  messages: {
    pending: string;
    success: string;
    error: string;
  }
) => {
  return toast.promise(promise, messages);
};